













































// Libraries
import { Component, Prop, Watch, VModel, Vue } from "vue-property-decorator";
// Types
import { Quote } from "@/types/quote";
type Mode = "create" | "update";

const emptyQuote: Quote = {
  author: "",
  quote: "",
};

@Component
export default class CreateOrUpdateModal extends Vue {
  @Prop({ type: Object, default: () => ({ ...emptyQuote }) })
  readonly quote!: Quote;
  @Prop({
    type: String,
    required: true,
    validator: (value: string): boolean => ["create", "update"].includes(value),
  })
  readonly mode!: Mode;

  @VModel()
  isOpen!: boolean;

  validationMessage = "This field is required";
  quoteModel: Quote = { ...emptyQuote };
  loading = false;

  get doesValidationPass(): boolean {
    return !!this.quoteModel.author.trim() && !!this.quoteModel.quote.trim();
  }

  @Watch("value")
  valueChanged(newVal: boolean): void {
    if (newVal) this.quoteModel = { ...this.quote };
  }

  created(): void {
    this.quoteModel = { ...this.quote };
  }

  save(): void {
    if (!this.doesValidationPass) return;

    this.loading = true;

    if (this.mode === "create") this.createQuote();
    else if (this.mode === "update") this.updateQuote();
  }

  createQuote(): void {
    this.$store
      .dispatch("createQuote", this.quoteModel)
      .then(this.resetModal)
      .finally(() => (this.loading = false));
  }

  updateQuote(): void {
    this.$store
      .dispatch("updateQuote", this.quoteModel)
      .then(this.resetModal)
      .finally(() => (this.loading = false));
  }

  resetModal(): void {
    this.isOpen = false;
    this.quoteModel = { ...emptyQuote };
  }
}
